import { Controller } from "@hotwired/stimulus"

// Opens a prompt for an optional rejection reason and submits the form.
// If the user cancels the prompt, nothing is submitted.
export default class extends Controller {
  static targets = ["reason"]

  static values = {
    message: { type: String, default: "Motivo de rechazo (opcional):" }
  }

  promptAndSubmit(event) {
    event.preventDefault()

    const text = window.prompt(this.messageValue, "")
    if (text === null) return

    if (this.hasReasonTarget) {
      this.reasonTarget.value = text
    }

    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit()
    } else {
      this.element.submit()
    }
  }
}
